import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from '../../shared/shared.module';
import { DocumentGenerationStoreModule } from './store/module';

@NgModule({
  declarations: [],
  imports: [SharedModule, CommonModule, TranslocoModule, DocumentGenerationStoreModule],
})
export class DocumentGenerationModule {}
